import Rete from "rete";

const tempActionSocket = new Rete.Socket(("TODO: temp action socket"))
const tempVideoSocket = new Rete.Socket(("TODO: temp vid socket"))
const tempPanoramaSocket = new Rete.Socket(("TODO: temp pano socket"))
const tempHotspotSocket = new Rete.Socket(("TODO: temp hotspot socket"))
const tempVoiceAnswerSocket = new Rete.Socket(("TODO: temp voice answer socket"))
const tempTextAnswerSocket = new Rete.Socket(("TODO: temp text answer socket"))

export {
    tempActionSocket,
    tempVideoSocket,
    tempPanoramaSocket,
    tempHotspotSocket,
    tempVoiceAnswerSocket,
    tempTextAnswerSocket
}